module.exports = __webpack_public_path__ + "img/image18@3x.edb66757.png";